/**
 * V2 Checkbox — Radix Checkbox themed to V2 tokens, faithful to the
 * `.check` rule in design_reference/styles/app.css (accent fill + accent-tx
 * check when on).
 */

import { forwardRef } from 'react';
import type { ComponentPropsWithoutRef, ElementRef } from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check } from 'lucide-react';
import { cn } from '../../../lib/utils';

/** V2 checkbox. */
export const Checkbox = forwardRef<
  ElementRef<typeof CheckboxPrimitive.Root>,
  ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'grid place-items-center w-[18px] h-[18px] shrink-0 rounded-[5px] outline-none',
      'bg-[var(--bg-inset)] border border-[var(--bd-strong)]',
      'focus-visible:ring-2 focus-visible:ring-[var(--accent-line)]',
      'data-[state=checked]:bg-[var(--accent)] data-[state=checked]:border-[var(--accent)]',
      'disabled:opacity-50 disabled:pointer-events-none',
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator>
      <Check className="w-[13px] h-[13px] text-[var(--accent-tx)]" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;
